import React from 'react';
import { connect } from 'react-redux'
import { Spin } from 'antd';
import { DcatCatalogs } from '../../redux';

/** Компонента, отображающая количество dcat:Catalog в графе.
 * 
 * В начале CatalogInGraphCount отображает загрузку, в этот момент запрашивается информация о количестве, если 
 * значение найдено, то отображается найденноей значения, если нет, то отображается 0 */
const Loading = () => <span>(<Spin size="small" />)</span>
const Label = ({value, count}) => {
    const label = parseInt((count)?(count):value);
    return (
        <span>({label})</span>
    )
}
  
class CatalogInGraphCount extends React.Component {
    state = {
        loaded: false,
        graph: null,
        value: 0
    };

    componentDidMount() {
        this.makeCount();
    }

    componentDidUpdate(prevProps, prevState) {
        this.makeCount();
    }

    makeCount () {
        if (this.state.loaded) return;
        const {graph, conditions} = this.props;
        //Здесь происходит пересчёт количества графов
        this.props.dispatch(DcatCatalogs.loadCatalogInGraphCount(graph, conditions))
            .then ((response) =>{
                let {count} = response;
                this.setState({loaded: true, value: parseInt(count), graph});
            })
            .catch(e => { 
                this.setState({loaded: true, value: "?", graph});
                console.error("Error!", e);
            });
    }

    render(){
        const Component = (this.state.loaded)? Label: Loading;
        return(
            <Component {...this.props} {...this.state}/>
        )
    }
}
export default connect()(CatalogInGraphCount);